module.exports = __webpack_public_path__ + "static/media/thabs.0092ac54.PNG";